import React from "react";
import styles from "./styles";
export const StaticBanner = () => {
  const classes = styles();
  return (
    <div className={classes.relativeContainer}>
      <div className={classes.bannerBackground}>
        <div className={classes.bannerDescriptionContainer}>
          <div className={classes.bannerDescription}>
            <div className={classes.bannerRectangle}></div>
            <div>
              <h1 className={classes.bannerTitle}>
                Queremos ayudarte con tu plan
              </h1>
            </div>
            <div className={classes.bannersubTitle}> Lo más buscado</div>
            <div className={classes.bannerDescriptionP}>
              <p>
                ¿Cuando usar mi plan?
                <br /> ¿Cómo pido mi reembolso?
                <br /> ¿Que cubre mi plan?
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
